// eslint-disable-next-line import/prefer-default-export
export const isEmpty = (value) => {
  return value && Object.keys(value).length === 0 && value.constructor === Object;
};
